import Assignedcomplaintsview from "../../../jsx/components/Dashboard/AssignedComplaints/assignedcomplaintsview";

const AssignedComplaintsViewWrapper = () => {
  return <Assignedcomplaintsview />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.compliance_officer_general];
export default constore(AssignedComplaintsViewWrapper);
